"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.double = void 0;

var integer_1 = require("./integer");

var tuple_1 = require("./tuple");

var doubleNext_1 = require("./_next/doubleNext");

function next(n) {
  return (0, integer_1.integer)(0, (1 << n) - 1);
}

var doubleFactor = Math.pow(2, 27);
var doubleDivisor = Math.pow(2, -53);

var doubleInternal = function doubleInternal() {
  return (0, tuple_1.tuple)(next(26), next(27)).map(function (v) {
    return (v[0] * doubleFactor + v[1]) * doubleDivisor;
  });
};

function double() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (typeof args[0] === 'object') {
    if (args[0].next) {
      return (0, doubleNext_1.doubleNext)(args[0]);
    }

    var min = args[0].min !== undefined ? args[0].min : 0;
    var max = args[0].max !== undefined ? args[0].max : 1;
    return doubleInternal().map(function (v) {
      return min + v * (max - min);
    }).filter(function (g) {
      return g !== max || g === min;
    });
  } else {
    var a = args[0];
    var b = args[1];
    if (a === undefined) return doubleInternal();
    if (b === undefined) return doubleInternal().map(function (v) {
      return v * a;
    }).filter(function (g) {
      return g !== a || g === 0;
    });
    return doubleInternal().map(function (v) {
      return a + v * (b - a);
    }).filter(function (g) {
      return g !== b || g === a;
    });
  }
}

exports.double = double;